
import Vue from 'vue';
import Candidates from '@custom/components/Candidates.vue';
import Countdown from '@custom/components/Countdown.vue';
import HeadlinesBlock from '@custom/components/HeadlinesBlock.vue';
import MainDates from '@custom/components/MainDates.vue';
import Faq from '@custom/components/Faq.vue';

import getBannerKey from '@root/modules/ads/utils/getBannerKey';
import AdFormBanner from '@ads/components/adForm/AdFormBanner.vue';
import BaseButton from '@core/components/UI/BaseButton.vue';

import { fetchData } from '@custom/core/modules/servives/fetchData';
import { FeedData } from '@custom/core/modules/types';

interface Data {
  data: FeedData;
  mainHeadlinesLimit: number;
}
interface Methods {
  getKey: (variables: any) => void;
  loadMoreHeadlines: () => void;
}
interface Computed {
  iframeurl: string;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    Candidates,
    Countdown,
    HeadlinesBlock,
    MainDates,
    Faq,
    AdFormBanner,
    BaseButton,
  },
  data() {
    return {
      data: {
        candidates: [{}],
        faq: [{}],
      },
      mainHeadlinesLimit: 5,
    };
  },
  methods: {
    getKey({ prefix, index }) {
      return getBannerKey({ prefix, route: this.$route, store: this.$store, index });
    },
    loadMoreHeadlines() {
      this.mainHeadlinesLimit = this.mainHeadlinesLimit + 5;
    },
  },
  computed: {
    iframeurl() {
      const d = new Date();
      const minutes = d.getMinutes();
      const hours = d.getHours();

      return 'https://www.delfi.lt/apps/rinkimai/2024/?v=' + hours + minutes;
    },
  },

  async mounted() {
    const data = await fetchData();
    this.data = data;

    window.addEventListener(
      'message',
      function (e) {
        console.log(e);
        if (!e.data) return;
        if (e.data[0] !== 'setHeight') return;
        if (e.data[2] === 'rinkimai2023') {
          const iframetoresize = document.getElementById('rinkimai2023');
          if (iframetoresize) {
            iframetoresize.style.height = e.data[1] + 'px';
          }
        }
      },
      false
    );
  },
});
